export default __webpack_public_path__ + "static/media/blue-logo_dalma_blue.35799f01.svg";